<template>
    <div v-if="state.employee" ref="panel" class="request-employee-panel" @keydown="onKeydown">
        <EmployeeInspector :employee="state.employee" :loading="state.loading" read-only
            card-source="requests" :access-message="state.error" @close="close" @reserve-returned="retry">
            <template #extra>
                <section v-if="canViewSizes" class="p-3 border-top">
                    <h6>Размеры СИЗ из карточки сотрудника</h6>
                    <div v-for="size in sizes" :key="size.key">{{ size.label }}: <strong>{{ size.value }}</strong></div>
                    <small v-if="!sizes.length" class="text-muted">Размеры пока не указаны.</small>
                </section>
            </template>
            <template #restricted>
                <section v-if="state.employee.contact_only" class="p-3 border-top" aria-label="Доступные контакты">
                    <h6>Доступные контакты</h6>
                    <div v-for="(contact, index) in state.employee.contacts" :key="index" class="mb-2">
                        <EmployeePhoneMenu v-if="contact.contact_type === 'phone'" :value="contact.value" />
                        <a v-else :href="`mailto:${contact.value}`">{{ contact.value }}</a>
                    </div>
                    <a v-if="state.employee.telegram_url" :href="state.employee.telegram_url" target="_blank" rel="noopener noreferrer">Telegram</a>
                    <span v-if="!state.employee.contacts.length && !state.employee.telegram_url" class="text-muted">Нет доступных контактов.</span>
                </section>
            </template>
            <template #status>
                <div v-if="state.retryable" class="p-3">
                    <b-button size="sm" variant="outline-primary" @click="retry">Повторить загрузку</b-button>
                </div>
            </template>
        </EmployeeInspector>
    </div>
</template>

<script>
import EmployeeInspector from '@/views/EmployeesWorkforce/EmployeeInspector.vue';
import EmployeePhoneMenu from '@/components/EmployeePhoneMenu.vue';
import {SIZE_LABELS} from '@/utils/requestPpe';

export default {
    components: {EmployeeInspector, EmployeePhoneMenu},
    props: {controller: {type: Object, required: true}},
    computed: {
        state() { return this.controller.state; },
        canViewSizes() {
            const access = this.state.employee && this.state.employee.card_access;
            return Boolean(access && access.can_open && access.view && access.view.ppe_sizes);
        },
        sizes() {
            const sizes = this.state.employee && this.state.employee.ppe_sizes || {};
            return Object.keys(SIZE_LABELS).filter(key => sizes[key]).map(key => ({key, label: SIZE_LABELS[key], value: sizes[key]}));
        }
    },
    watch: {
        'state.target'(target) {
            if (target) this.$nextTick(() => {
                const close = this.$el.querySelector('.workforce-inspector__close');
                if (close) close.focus({preventScroll: true});
            });
        }
    },
    methods: {
        retry() { this.controller.open(this.state.target); },
        close() {
            const trigger = this.state.trigger;
            this.controller.close();
            this.$nextTick(() => { if (trigger && trigger.isConnected) trigger.focus({preventScroll: true}); });
        },
        onKeydown(event) {
            if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.close(); }
            if (event.key !== 'Tab') return;
            const elements = Array.from(this.$el.querySelectorAll('aside button, aside a[href], aside input, aside select, aside textarea, aside [tabindex="0"]'))
                .filter(element => !element.disabled && element.getClientRects().length);
            const first = elements[0], last = elements[elements.length - 1];
            if (!first) return;
            if (event.shiftKey && event.target === first) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && event.target === last) { event.preventDefault(); first.focus(); }
        }
    }
};
</script>

<style scoped>
.request-employee-panel >>> .workforce-inspector__body { overscroll-behavior: contain; }
</style>
